import React from "react";
import UIBirthDaySelect from "../../atomic/molecular/BirthDaySelect"

const BirthdaySelect = ({ getCustomAttribute }) => {
  return (
    <UIBirthDaySelect
      label="生年月日(自動入力)"
      defaultYear={getCustomAttribute("birth_year")}
      defaultMonth={Number(getCustomAttribute("birth_month"))}
      defaultDay={Number(getCustomAttribute("birth_day"))}
      disabled={true}
    />
  );
};

export default BirthdaySelect;
